import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const FETCH_INVESTCORE_PROGRAM_ORDER_LIST_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_PROGRAM_ORDER_LIST_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_PROGRAM_ORDER_LIST_API_ID,
  ({ id, ...params }) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/program-orders`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
